import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Importa le immagini (stesse immagini importate in AvatarSelection)
import avatar1 from '../assets/images/avatar01.png';
import avatar2 from '../assets/images/avatar02.png';
import avatar3 from '../assets/images/avatar03.png';
import avatar4 from '../assets/images/avatar04.png';
import avatar5 from '../assets/images/avatar05.png';
import avatar6 from '../assets/images/avatar06.png';
import avatar7 from '../assets/images/avatar07.png';
import avatar8 from '../assets/images/avatar08.png';
import p_avanti from "../assets/images/p_avanti.png";

// Map degli avatar in base al nome
const avatarMap = {
    avatar01: avatar1,
    avatar02: avatar2,
    avatar03: avatar3,
    avatar04: avatar4,
    avatar05: avatar5,
    avatar06: avatar6,
    avatar07: avatar7,
    avatar08: avatar8,
};

const IpadMyProfile = () => {
    const [nickname, setNickname] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedAvatar, setSelectedAvatar] = useState(null);
    const [userId, setUserId] = useState(null);

    // Recupera l'avatar selezionato e l'ID utente dallo stato
    useEffect(() => {
        if (location.state && location.state.avatar && location.state.userId) {
            setSelectedAvatar(location.state.avatar);
            setUserId(location.state.userId);
        } else {
            // Se non ci sono avatar e userId, torna alla pagina iniziale
            //navigate('/ipad/register');
        }
    }, [location.state, navigate]);

    const handleSubmitNickname = async () => {
        if (nickname && userId && selectedAvatar) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/setnickname`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        userId,
                        avatar: selectedAvatar,
                        nickname,
                    }),
                });

                if (response.ok) {
                    console.log('Nickname e avatar associati con successo!');

                    navigate('/ipad/lobbygame', {
                        state: { userId, avatar: selectedAvatar, nickname },
                    });

                } else {
                    alert('Errore durante l\'associazione del nickname');
                }
            } catch (error) {
                console.error('Errore:', error);
                //alert('Errore di connessione');
            }
        } else {
            alert('Prego, inserire un nickname!');
        }
    };

    return (

        <div className="ipad_nickname flex flex-col w-full h-full  items-center justify-center relative bg-fixed">


            <div className="bg-black p-8 rounded-3xl shadow-md w-[547px] h-[526px] top-[158px] relative opacity-90">


                <div className="flex justify-center mb-4">
                    {selectedAvatar && (
                        <img
                            src={avatarMap[selectedAvatar]}
                            alt={`Avatar selezionato: ${selectedAvatar}`}
                            className="w-[170px] h-auto rounded-full mb-4 items-center"
                        />
                    )}
                </div>

                {/* Campo per inserire il nickname */}
                <div className="mb-4 flex items-center">
                        <label className="w-32 text-xl font-medium text-white">NICKNAME</label>
                        <input
                            type="text"
                            value={nickname}
                            onChange={(e) => setNickname(e.target.value)}
                            className="flex-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                            required
                        />
                </div>


                <div className="flex justify-center pt-10">

                    <button
                        onClick={handleSubmitNickname}
                        className="w-auto"
                        style={{background: 'none', border: 'none'}}
                    >
                        <img
                            src={p_avanti}
                            alt="Avanti"
                            className="w-[225px] h-auto"
                        />
                    </button>
                </div>



                </div>

        </div>
    );
};

export default IpadMyProfile;
